<template>
  <div class="ai-result">
    <div style="overflow: hidden" >
      <el-button
        type="text"
        size="mini"
        style="float: left"
        v-show="isReturnChina"
        @click="returnChinaFn()"
        ><i class="iconfont el-icon-d-arrow-left">返回中国地图</i></el-button
      >
    </div>
    <div
      class="graph"
      id="echart_province"
      ref="echart_province"
    ></div>
  </div>
</template>
<script>
import * as echarts from "echarts";
import chinamap from "@/assets/json/china.json";
import { Decimal } from "decimal.js";
export default {
  props: ["aiResultData"],
  data() {
    return {
      activeName: "first",
      provinces: {
        台湾: "taiwan",
        河北: "hebei",
        山西: "shanxi",
        辽宁: "liaoning",
        吉林: "jilin",
        黑龙江: "heilongjiang",
        江苏: "jiangsu",
        浙江: "zhejiang",
        安徽: "anhui",
        福建: "fujian",
        江西: "jiangxi",
        山东: "shandong",
        河南: "henan",
        湖北: "hubei",
        湖南: "hunan",
        广东: "guangdong",
        海南: "hainan",
        四川: "sichuan",
        贵州: "guizhou",
        云南: "yunnan",
        陕西: "shanxi1",
        甘肃: "gansu",
        青海: "qinghai",
        新疆: "xinjiang",
        广西: "guangxi",
        内蒙古: "neimenggu",
        宁夏: "ningxia",
        西藏: "xizang",
        北京: "beijing",
        天津: "tianjin",
        上海: "shanghai",
        重庆: "chongqing",
        香港: "xianggang",
        澳门: "aomen",
      },
      pyName: "",
      isReturnChina: false,
      coreWords: [],
      dialogVisible: false,
      twolevel: [],
    };
  },
  watch: {
    aiResultData: {
      handler(val) {
        this.chinaMaprsult("china", chinamap);
        // this.getData();
      },
      deep: true,
    },
  },
  created() {},
  mounted() {
    this.$nextTick((_) => {
      this.chinaMaprsult("china", chinamap);
      // this.getData();
    });
  },
  methods: {

    /*
      显示中国地图
    */
    // init() {
    //   let mapData = []; //定义数组

    //   if (this.aiResultData.place) {
    //     var sumByProvince = {};

    //     for (var province in this.aiResultData.place) {
    //       var sum = 0;
    //       var cities = this.aiResultData.place[province];

    //       for (var city in cities) {
    //         sum += cities[city];
    //       }

    //       sumByProvince[province] = sum;
    //     }
    //     console.log(sumByProvince);
    //     for (let key in sumByProvince) {
    //       let param = {
    //         name: key,
    //         value: sumByProvince[key],
    //       };
    //       mapData.push(param);
    //     }
    //   }
    //   console.log(this.$echarts, 'this.$echarts')
    //   // 2. 注册可用的地图，只在 geo 组件或者map图表类型中使用
    //   this.$echarts.registerMap("china", chinamap); //用导入的json文件注册一个name:china的地图组件

    //   // 3. 设置图表 option
    //   var option = {
    //     geo: [
    //       {
    //         zlevel: 2, //geo显示级别，默认是0
    //         map: "china", //地图名
    //         roam: false, //不开启缩放和平移
    //         zoom: 1, //视角缩放比例
    //         coordinateSystem: "geo",
    //         label: {
    //           normal: {
    //             show: true,
    //             fontSize: "12",
    //             color: "rgba(0,0,0,0.7)",
    //           },
    //         },
    //         itemStyle: {
    //           //顶层地图的样式，如地图区域颜色，边框颜色，边框大小等
    //           normal: {
    //             borderColor: "#409EFE",
    //             borderWidth: 0.2,
    //           },
    //         },
    //       },
    //       {
    //         map: "china",
    //         roam: false, //roam与上一个geo配置相同
    //         zoom: 1,
    //         itemStyle: {
    //           //底层地图样式
    //           normal: {
    //             //此处border设置你想要显示的地图外边框样式，可设置border颜色，阴影等
    //             borderColor: "#409EFE",
    //             borderWidth: 2,
    //             shadowColor: "rgba(0, 0, 0, 0.05)",
    //             shadowOffsetY: 20,
    //             shadowBlur: 20,
    //           },
    //           emphasis: {
    //             areaColor: "#4E70C2", //鼠标选择区域颜色
    //             shadowOffsetX: 0,
    //             shadowOffsetY: 0,
    //             shadowBlur: 20,
    //             borderWidth: 0,
    //             shadowColor: "rgba(0, 0, 0, 0.5)",
    //           },
    //         },
    //       },
    //     ],
    //     series: [
    //       {
    //         type: "map",
    //         map: "china", //使用 registerMap 注册的地图名称
    //         geoIndex: 0,
    //         label: {
    //           show: true,
    //         },
    //         data: mapData,
    //       },
    //     ],
    //     visualMap: {
    //       min: 0,
    //       max: 300,
    //       inRange: {
    //         color: ["white", "#4E70C2"], //控制颜色渐变的范围
    //       },
    //       calculable: true, //出现滑块
    //     },
    //   };

    //   // 4. 显示地图
    //   const myChart = echarts.init(this.$refs.echart_china, "null", {
    //       renderer: "svg" //以svg渲染可以减少内存消耗
    //     }
    //   );
    //   this.$nextTick(() => {
    //     myChart.setOption(option); // 用 option 和 option2 效果一样
    //   });
    //   window.addEventListener("resize", () => {
    //     //页面大小变化后Echarts也更改大小
    //     myChart.resize();
    //   });
    // },
    chinaMapHidden(chinaMap) {
      let that = this;
      chinaMap.off("click");
      chinaMap.on("click", async function (params) {
        if (params.name in that.provinces) {
          that.pyName = params.name;
          let s = require(`../../../assets/json/province/${
            that.provinces[params.name]
          }`);
          if (s) {
            that.twolevel = s;
            that.chinaMaprsult(params.name, s);
          }
        }
        if (params.data.value == 0) {
          // that.$message({
          //   type: "warning",
          //   message: params.data.name + "暂无文章",
          // });
        } else {
          // that.$emit("getMapArticle",params.data.name );
        }
      });
    },
    chinaMaprsult(name, map) {
      let mapData = []; //定义数组
      if (name == "china") {
        this.isReturnChina = false;
        if (this.aiResultData.place) {
          //循环数据获取到当前数据返回的值 并求对应对象中的和
          var sumByProvince = {};

          for (var province in this.aiResultData.place) {
            var sum = 0;
            var cities = this.aiResultData.place[province];

            for (var city in cities) {
              sum += cities[city];
            }

            sumByProvince[province] = sum;
          }
          //对象对比  获取没有返回的城市  并补0
          let differentValues = {};

          for (let key in sumByProvince) {
            if (
              sumByProvince.hasOwnProperty(key) &&
              !this.provinces.hasOwnProperty(key)
            ) {
              differentValues[key] = sumByProvince[key];
            }
          }

          for (let key in this.provinces) {
            if (
              this.provinces.hasOwnProperty(key) &&
              !sumByProvince.hasOwnProperty(key)
            ) {
              differentValues[key] = this.provinces[key];
            }
          }

          for (var key in differentValues) {
            differentValues[key] = 0;
          }
          //合并两个对象
          let result = { ...sumByProvince, ...differentValues };

          for (let key in result) {
            let param = {
              name: key,
              value: result[key],
            };
            mapData.push(param);
          }
        }
      } else {
        this.isReturnChina = true;
        if (this.aiResultData.place) {
          let params = {};
          for (let key in this.aiResultData.place) {
            if (this.pyName == key) {
              params = this.aiResultData.place[key];
            }
          }
          let arr = [];
          if (JSON.stringify(this.twolevel) != "{}") {
            let obj = this.twolevel;
            console.log(obj);
            obj.features.forEach((item) => {
              arr.push({ name: item.properties.name, value: 0 });
            });
          }
          let brr = [];
          for (let key in params) {
            let param = {
              name: key + "市",
              value: params[key],
            };
            brr.push(param);
          }
          mapData = [...arr, ...brr];
          mapData = mapData.reduce((obj, item) => {
            let find = obj.find((i) => i.name === item.name);
            let _d = {
              ...item,
            };
            find ? (find.value += item.value) : obj.push(_d);
            return obj;
          }, []);
        }
      }
      this.$echarts.registerMap(name, map);
      var options = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            if (params.data) {
              return (
                params.name + "<br>" + "文章数：" + params.data.value + "<br>"
              );
            }
          },
        },
        geo: [
          {
            zlevel: 2, //geo显示级别，默认是0
            map: name, //地图名
            roam: false, //不开启缩放和平移
            zoom: 1, //视角缩放比例
            coordinateSystem: "geo",
            label: {
              normal: {
                show: true,
                fontSize: "12",
                color: "rgba(0,0,0,0.7)",
              },
            },
            itemStyle: {
              //顶层地图的样式，如地图区域颜色，边框颜色，边框大小等
              normal: {
                borderColor: "#409EFE",
                borderWidth: 0.2,
              },
            },
          },
          {
            map: name,
            roam: false, //roam与上一个geo配置相同
            zoom: 1,
            itemStyle: {
              //底层地图样式
              normal: {
                //此处border设置你想要显示的地图外边框样式，可设置border颜色，阴影等
                borderColor: "#409EFE",
                borderWidth: 2,
                shadowColor: "rgba(0, 0, 0, 0.05)",
                shadowOffsetY: 20,
                shadowBlur: 20,
              },
              emphasis: {
                areaColor: "#4E70C2", //鼠标选择区域颜色
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 20,
                borderWidth: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        series: [
          {
            type: "map",
            map: "china", //使用 registerMap 注册的地图名称
            geoIndex: 0,
            label: {
              show: true,
            },
            data: mapData,
          },
        ],
        visualMap: {
          min: 0,
          max: Math.max(...Object.values(sumByProvince)) ? Math.max(...Object.values(sumByProvince)) : 10, // 取最大值
          // itemHeight: 100,
          inRange: {
            color: ["white", "#4E70C2"], //控制颜色渐变的范围
          },
          calculable: false, //出现滑块
        },
      };
      this.$nextTick(() => {
        let chinaMap = echarts.init(this.$refs.echart_province, "null", {
          renderer: "svg" //以svg渲染可以减少内存消耗
        }
      );
        chinaMap.setOption(options);
       // this.chinaMapHidden(chinaMap); 只展示中国地图，不用点击下一层
      });
    },
    // 返回中国地图
    returnChinaFn() {
      this.$nextTick((_) => {
        this.chinaMaprsult("china", chinamap);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.ai-result {
  margin-top: 0 !important;
  h2 {
    color: rgba(30, 30, 30, 0.95);
    display: flex;
    align-items: center;
    font-size: 14px;
    &:before {
      content: "";
      width: 3px;
      height: 20px;
      display: block;
      background-color: #5386d7;
      margin-right: 5px;
    }
  }
}
.hotspot-tab {
  display: flex;
  position: absolute;
  top: -7%;
  right: 0%;
}
#echart_china {
  width: 100%;
  height: 500px;
  background-color: #fff;
}
.graph {
  width: 700px;
  height: 500px;
  margin: 0 auto;;
}
.tabs-box {
  height: 30px;
  line-height: 30px;
  width: 420px;
  margin: 0 auto;
  margin-top: 10px;
  margin-bottom: 10px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--bg);

  > div {
    width: 50%;
    text-align: center;
    color: var(--text-2);
    position: relative;
    cursor: pointer;

    &:hover {
      color: var(--text-1);
    }
    &.active {
      font-size: 14px;
      font-weight: 500;
      color: var(--brand);
      background: #ecf5ff;
    }
  }
}
.amplify {
  display: flex;
  position: absolute;
  top: 20%;
  right: 0%;
}
</style>
